import { useGetProductsMetaQuery } from "../../../api/restApiSlice";

export function useProductMeta() {
  const { data } = useGetProductsMetaQuery();
  return {data};
}
